<template>
   <div class="bat-result-scenario" >
      <result-card
         class="scenario-card"
         v-for="([title, infos], index) in Object.entries(batScenarioInfos)"
         :key="index"
         :title="title"
         :infos="infos"
      />
      <div class="parameters-card scenario-card">
         <div class="title">Parameters Used for the Project</div>
         <parameter-tabs/>
      </div>
   </div>
</template>

<script>
import ResultCard from '../../../../organisms/Home/ResultCard';
import ParameterTabs from '../ParameterTabs';
import { mapGetters } from 'vuex';
import { formatLatLng } from '../../../../../js/ui-helpers';

export default {
   name: 'bat-result-scenario',
   components: {
      ResultCard,
      ParameterTabs,
   },
   computed: {
      ...mapGetters(["getBatResults"]),
      batScenarioInfos()
      {
         const results = this.getBatResults;
        if (!results) return [];
        
        const {municipality, physical_information} = results;
        const formatMinMax = (value, unit) => ({Min: `${value.min}${unit}`, Max: `${value.max}${unit}`});
        return {
            "General Information": {
                "State" : municipality.state,
                "District" : municipality.district ,
                "Gau-NagarPalika": municipality.name ,
                "Local Name": results.local_name ,
                "Latitude": formatLatLng(results.latitude) ,
                "Longitude" : formatLatLng(results.longitude) ,
            },
            "Physical Informations": {
                "Avg.Temperature": physical_information.avg_temp,
                "Elevation": formatMinMax(physical_information.elevation_minmax, "m.") ,
                "Slope": formatMinMax(physical_information.slope_minmax, "°") ,
                "Aspect": formatMinMax(physical_information.aspect_minmax, "°"),
            },
            "Socio-Economic Informations": {
                "Number of Houses": results.num_house ,
                "Number of Houses (OSM)": results.osm_buildings,
                "Household": results.num_household ,
                "Population (Male)": results.male_pop ,
                "Poulation (Female)": results.female_pop ,
            },
            "Feasible Energy Technologies": {
                "Tier": results.tier,
                "Demand": `${results.total_demand_kW} kW`,
                "Suitable Energy": Object.values(results.feasible_energy_techs),
            },
        };
      }
   },
};
</script>

<style lang="scss">
.bat-result-scenario {
   background: transparent;
   border: none;
   display: flex;
   flex-wrap: wrap;
   .scenario-card {
      flex: 1 0 24em;
   }
   .parameters-card {
      flex: 1 0 100%;
      border-radius: 0.25em;
      background: white;
      margin: 0.5em;
      > .title {
         padding: 0.6em 1em;
         border-radius: 0.25em 0.25em 0 0;
         color: $font-color;
      }
   }
}
</style>